import React from "react";

import Dashboard from "../../views/layouts/Dashboard";
import type { RouteProps } from "../routeTypes";
import adminRoutes from "./admin";
import clientRoutes from "./client";
import distributor from "./distributor";

const index = (props: RouteProps) => ({
  path: "/",
  authorize: ["auth"],
  component: <Dashboard />,
  subRoutes: [...clientRoutes(props), ...adminRoutes(props), ...distributor(props)],
});

export default index;
